export default function em(size) {
  const emSize = parseFloat(size.replace('px', '')) / 16

  return `${emSize}em`
}
